import { FC, useMemo } from "react"
import IframeResizer from "iframe-resizer-react";
import { embedHtml } from "lib/utils";

export const AssetIframe: FC<{  data: any }> = ({ data }) => {
  const html = useMemo(() => embedHtml(data), [data]);

  return (
    <div className="field-html">
      <IframeResizer
        className="asset__iframe-resizer"
        checkOrigin={false}
        sizeWidth={true}
        heightCalculationMethod="taggedElement"
        widthCalculationMethod="taggedElement"
        srcDoc={html}
      />
    </div>
  );
};
